// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"styles_fieldset__1sCK5","fieldset-column":"styles_fieldset-column___GjBS","assessment-setup":"styles_assessment-setup__2MA0d"};